/**
 * LinkIcon/index.js
 * desc: system icon for link step type
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LinkIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="link icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.link.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fillRule="evenodd" d="M12.033 1.367a4.667 4.667 0 016.6 6.599l-4.243 4.242a4.667 4.667 0 01-2.163 1.227h-.037l-.193.04-.107.02-.23.033h-.113c-.05 0-.098.005-.142.01a1.296 1.296 0 01-.095.01l-.2.023h-.253a4.643 4.643 0 01-.497-.046 5.4 5.4 0 01-.403-.084l-.197-.053a2.68 2.68 0 01-.213-.07c-.026-.01-.052-.02-.078-.028-.046-.017-.091-.033-.136-.052l-.07-.03a4.626 4.626 0 01-1.473-.994 1.333 1.333 0 010-1.879 1.367 1.367 0 011.873 0 2 2 0 002.827 0l1.093-1.086.027-.03 3.127-3.123a2 2 0 10-2.83-2.83l-2.51 2.507a.333.333 0 01-.364.073 5.601 5.601 0 00-2.13-.417H8.78a.333.333 0 01-.243-.57l3.496-3.492zm-.613 5.798c.284.18.546.392.783.63.27.271.411.645.387 1.027-.023.32-.16.62-.387.846a1.367 1.367 0 01-1.873 0 2 2 0 00-2.826 0l-4.257 4.253a2 2 0 102.83 2.83l2.517-2.52a.333.333 0 01.363-.073 5.613 5.613 0 002.133.413h.133a.333.333 0 01.237.57l-3.5 3.5A4.638 4.638 0 014.664 20a4.666 4.666 0 01-3.3-7.962l4.24-4.243a4.668 4.668 0 015.817-.63z"/></svg>
    </IconButton>
);


export default LinkIcon;
